import React from "react";
var __jsx = React.createElement;
import { PURCHASE_METHOD_CASH, useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import RiyalSymbol from "@componentsShared/InputCurrency/RiyalSymbol";
import RadioCardNew from "@/pages/checkout/pre-checkout/RadioCard/RadioCardNew";
import { useTranslation } from "@i18n";
var CashOptionTwo = function CashOptionTwo() {
  var _checkoutOrder$story_, _checkoutOrder$story_2;
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    purchaseMethod = _useCheckoutOrder$sta.purchaseMethod;
  var _useCheckoutOrder$act = useCheckoutOrder().actions,
    action__setPurchaseMethod = _useCheckoutOrder$act.action__setPurchaseMethod,
    action__setShowStory = _useCheckoutOrder$act.action__setShowStory;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioCardNew, {
    id: "precheckout-cash-option",
    name: "cash",
    value: PURCHASE_METHOD_CASH,
    checked: purchaseMethod === PURCHASE_METHOD_CASH,
    onChange: function onChange(e) {
      action__setPurchaseMethod(e.target.value);
    },
    storyText: t("how_buy_car_syarah", {
      ns: "web_pre_checkout"
    }),
    title: tShort("pre-checkout/cash_title", {
      ns: "web_pre_checkout"
    }),
    description: tShort("pre-checkout/cash_description", {
      ns: "web_pre_checkout"
    }),
    ctaText: tShort("pre-checkout/how_to_cash_sub", {
      ns: "web_pre_checkout"
    }),
    onClickCta: function onClickCta(e) {
      action__setShowStory(true);
      e.stopPropagation();
      e.preventDefault();
    },
    story: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_ = checkoutOrder.story_section) === null || _checkoutOrder$story_ === void 0 ? void 0 : (_checkoutOrder$story_2 = _checkoutOrder$story_.cash_story) === null || _checkoutOrder$story_2 === void 0 ? void 0 : _checkoutOrder$story_2.data.map(function (story, idx) {
      var _checkoutOrder$story_3;
      return /*#__PURE__*/React.createElement("div", {
        key: "stry" + idx,
        className: "singleStry",
        "data-color": "linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%);"
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          textAlign: "center"
        }
      }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_3 = checkoutOrder.story_section) === null || _checkoutOrder$story_3 === void 0 ? void 0 : _checkoutOrder$story_3.cash_story.title), /*#__PURE__*/React.createElement("img", {
        src: story.image,
        alt: "story"
      }));
    }),
    priceBox: /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1.5 items-center py-px px-1.5 rounded-md bg-[#E6F7EF]"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-1"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-[#00B362] font-bold text-base leading-6"
    }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.arboun), /*#__PURE__*/React.createElement(RiyalSymbol, {
      className: "text-[#00B362] text-base font-bold leading-6"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-start text-[#00143C] text-xs font-semibold leading-tight"
    }, t("refundable", {
      ns: "web_checkout_cash"
    })))
  }));
};
export default CashOptionTwo;